import React from 'react';
import i18n from '../../../i18n/i18n';
import axios from '../../../utils/AxiosWrapper';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Card, Link, Typography } from '@material-ui/core';
import DatePickerMeteo from '../../../utils/DatePickerMeteo';
import { formatData, formatForecast, formatDisease } from './../DataFormatters';
import { withStyles } from '@material-ui/core/styles';
import { MoonLoader } from 'react-spinners';
import MeteoTable from '../MeteoTable';

const styles = {};

export class RapseedPollenBeetleFlight extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            station_id: this.props.row.uid,
            startDate: moment().subtract(1, 'days'),
            endDate: moment(),
            disease1: {},
            disease2: {},
            data: {},
            loadDisease: true,
            loadData: true
        };
    }

    setDates = (start, end) => { this.setState({ startDate: start, endDate: end }, () => { this.getPessl(); }); }

    // Get funkcije za preuzimanje podataka sa stanica samo po potrebi ubaciti, pored Disease-a uvek mora i Data zbog datuma
    getDisease = (path, disease) => {
        let obj = {};
        axios.post('/api/testMeteo/meteo', path)
            .then(res => { obj = formatDisease(res, obj); this.setState({ [disease]: obj, loadDisease: false }); })
            .catch(err => console.log('Error: ', err))
    }

    getData = (path) => {
        axios.post('/api/testMeteo/meteo', path)
            .then(res => { let obj = formatData(res); this.setState({ data: obj, loadData: false }); })
            .catch(err => console.log('Error: ', err))
    }

    // getForecast = (path) => {
    //     axios.post('/api/testMeteo/meteo', path)
    //         .then(res => { let obj = formatForecast(res); this.setState({ forecast: obj }); })
    //         .catch(err => console.log('Error: ', err))
    // }

    getPessl = () => {
        let start_date = moment(this.state.startDate).unix();
        let end_date = moment(this.state.endDate).unix();
        let station_id = this.state.station_id;

        // URL-ovi za podatke sa meteo stanica
        let disease_path = '/data/' + station_id + '/hourly/from/' + start_date + '/to/' + end_date;
        let forecast_path = '/forecast/' + station_id + '/basic-1h';
        let data_path = '/data/' + station_id + '/hourly/from/' + start_date + '/to/' + end_date;

        // Disease mora POST method, za Data i Forecast mora GET method
        this.getDisease({ path: disease_path, name: "Rapseed/PollenBeetleFlight", method: "POST" }, 'disease1');
        this.getData({ path: data_path, method: "GET" });
        // this.getForecast({ path: forecast_path, name: 'general7', method: "POST" });
    }

    render() {
        const { classes } = this.props;

        //console.log('disease1: ', this.state.disease1);
        // console.log('disease2: ', this.state.disease2);
        // console.log('data meteo: ', this.state.data);

        let graph1 = {};
        let graph2 = {};
        let graph3 = {};
        let graph4 = {};

        const options = {
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            maxTicksLimit: 2
                        }
                    },
                    // {
                    //     type: 'linear',
                    //     display: true,
                    //     position: 'right',
                    //     id: 'y-axis-2',
                    //     gridLines: {
                    //         drawOnChartArea: false,
                    //     },
                    //     ticks: {
                    //         beginAtZero: true,
                    //         min: 0,
                    //     }
                    // },
                ],
            },
        };

        const options2 = {
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-5',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[°C]'
                        },
                    },
                    // {
                    //     type: 'linear',
                    //     display: true,
                    //     position: 'right',
                    //     id: 'y-axis-6',
                    //     gridLines: {
                    //         drawOnChartArea: false,
                    //     },
                    //     ticks: {
                    //         beginAtZero: false,
                    //         min: 40,
                    //         max: 100
                    //     }
                    // },
                ],
            },
        };

        // const options3 = {
        //     scales: {
        //         yAxes: [
        //             {
        //                 type: 'linear',
        //                 display: true,
        //                 position: 'left',
        //                 id: 'y-axis-3',
        //                 gridLines: {
        //                     drawOnChartArea: false
        //                 },
        //                 scaleLabel: {
        //                     display: true,
        //                     labelString: '[mm]'
        //                 },
        //                 ticks: {
        //                     beginAtZero: true,
        //                     min: 0,
        //                     max: 4
        //                 }
        //             },
        //             {
        //                 type: 'linear',
        //                 display: true,
        //                 position: 'right',
        //                 id: 'y-axis-4',
        //                 gridLines: {
        //                     drawOnChartArea: false,
        //                 },
        //                 scaleLabel: {
        //                     display: true,
        //                     labelString: '[min/h]'
        //                 },
        //                 ticks: {
        //                     beginAtZero: true,
        //                     min: 0,
        //                     max: 60
        //                 }
        //             },
        //         ],
        //     },
        // };

        if (
            this.state.data.dates &&
            this.state.disease1 &&
            this.state.disease2
        ) {
            graph1 = {
                labels: this.state.data.dates,
                datasets: [
                    {
                        data: this.state.disease1['pollen_beetle_flight'],
                        label: i18n.t('Pollen beetle flight risk'),
                        backgroundColor: 'transparent',
                        borderColor: 'red',
                        type: 'line',
                        borderWidth: 2,
                        pointRadius: this.state.data.dates.length > 72 ? 0 : 2,
                        yAxisID: 'y-axis-1',
                    },
                    // {
                    //     data: this.state.disease1['Mycotoxin'],
                    //     label: i18n.t('Mycotoxin'),
                    //     type: 'line',
                    //     backgroundColor: 'transparent',
                    //     borderColor: 'green',
                    //     borderWidth: 2,
                    //     pointRadius: this.state.data.dates.length > 72 ? 0 : 2,
                    //     yAxisID: 'y-axis-2',
                    // },
                ],
            };
            graph3 = {
                labels: this.state.data.dates,
                datasets: [
                    {
                        data: this.state.data.temperatures,
                        label: i18n.t('Temperature [°C]'),
                        backgroundColor: 'transparent',
                        borderColor: 'red',
                        type: 'line',
                        borderWidth: 2,
                        pointRadius: this.state.data.dates.length > 72 ? 0 : 2,
                        yAxisID: 'y-axis-5',
                    },
                    {
                        data: this.state.data.soil_temperatures,
                        label: i18n.t('Soil temperature [°C]'),
                        type: 'line',
                        backgroundColor: 'transparent',
                        borderColor: 'rgb(234, 182, 79)',
                        borderWidth: 2,
                        pointRadius: this.state.data.dates.length > 72 ? 0 : 2,
                        yAxisID: 'y-axis-5',
                    },

                ],
            };
            // graph4 = {
            //     labels: this.state.data.dates,
            //     datasets: [
            //         {
            //             data: this.state.data.precipitation,
            //             label: i18n.t('Precipitation [mm]'),
            //             backgroundColor: 'rgb(70, 130, 180,0.9)',
            //             borderColor: '#4682B4',
            //             type: 'line',
            //             borderWidth: 2,
            //             pointRadius: this.state.data.dates.length > 72 ? 0 : 2,
            //             yAxisID: 'y-axis-3',
            //         },
            //         {
            //             data: this.state.data.leaf_wetness,
            //             label: i18n.t('Leaf wetness [min/h]'),
            //             backgroundColor: '#7CFC00',
            //             borderColor: '#7CFC00',
            //             type: 'bar',
            //             borderWidth: 2,
            //             pointRadius: this.state.data.dates.length > 72 ? 0 : 2,
            //             yAxisID: 'y-axis-4',
            //         },
            //     ],
            // };
        };

        return (
            <div style={{ paddingLeft: '35px' }}>
                <div style= {{display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                        <p style={{fontSize: 20, marginRight: 4 }}>{i18n.t('Pollen beetle flight')}</p>
                        <p style={{fontSize: 20, fontStyle: 'italic'}}>(Meligethes aeneus)</p>
                        </div>
                </div>
                <DatePickerMeteo startDate={this.state.startDate} endDate={this.state.endDate} setDates={this.setDates} getPessl={this.getPessl} />
                {(this.state.loadDisease === true || this.state.loadData === true) && <div style={{ marginLeft: '39%', marginTop: '14%' }}> <MoonLoader loading={this.state.loadDisease === true || this.state.loadData === true} size={100} /></div>}
                {this.state.loadDisease === false && this.state.loadData === false &&
                    <div>
                        <div style={{ width: '95%', marginTop: '10px' }}>
                            <Bar data={graph1} height={150} width={600} options={options} />
                        </div>
                        <div style={{ padding: '20px', marginRight: '35px', borderRadius: '8px', boxShadow: ' 0 5px 10px rgba(154, 160, 185, 0.2), 0 15px 40px rgba(166, 173, 201, 0.1)', backgroundColor: 'white !important' }}>
                            <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>Info:</p>
                            <p>{i18n.t('A value of 1 indicates the potential presence of individuals of Rape shiner, which is predicted based on the air temperature and the temperature of the soil layer (0-10℃).')}</p>
                            <p>{i18n.t('If the value is 0℃, then the model does not overlook the disease, because adequate weather conditions have not been achieved.')}</p>
                        </div>
                        <div style={{ width: '95%', marginTop: '80px'}}>
                            <Bar data={graph3} height={200} width={400} options={options2} />
                        </div>
                        <MeteoTable data={{
                            headers: [i18n.t('Date and time'), i18n.t('Temperature [°C]'), i18n.t('Soil temperature [°C]') ],
                            dates: this.state.data.dates,
                            temperatures: this.state.data.temperatures,
                            soil_temperatures: this.state.data.soil_temperatures
                        }} />
                        <div style={{ marginTop: '20px' }}></div>
                    </div>
                }
            </div>
        );
    }
};

export default withStyles(styles)(RapseedPollenBeetleFlight);
